import styled from "styled-components";
import Button from "../assets/Buttons";

export const Container = styled.div`
  width: 100%;
  max-height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const SixthBox = styled.div`
  flex: 0 0 calc(100% / 6 - 2rem);
  @media (max-width: 1111px) {
    flex: 0 0 calc(25% - 2rem);
  }
  @media (max-width: 820px) {
    flex: 0 0 calc(50% - 1.5rem);
  }
`;

export const QuarterBox = styled.div`
  flex: 0 0 calc(25% - 2rem);
  @media (max-width: 820px) {
    flex: 0 0 calc(50% - 1.5rem);
  }
`;

export const ThirdBox = styled.span`
  flex: 0 0 calc(33.33% - 2rem);
  @media (max-width: 820px) {
    flex: 0 0 calc(50% - 1.5rem);
  }
`;

export const HalfBox = styled.div`
  flex: 0 0 calc(50% - 2rem);
  @media (max-width: 820px) {
    flex: 0 0 calc(100% - 2rem);
  }
`;

export const FullBox = styled.div`
  flex: 0 0 calc(100% - 2rem);
`;

export const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  @media (max-width: 820px) {
    justify-content: center;
    gap: 1rem;
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: end;
  min-height: 3.25rem;
  text-align: bottom;
  width: 100%;
  font-size: 1.0625rem;
  margin-bottom: 0.5rem;
`;

export const TextInput = styled.input.attrs({
  autoComplete: "new-password",
})`
  padding: 0.875rem 1rem;
  width: calc(100% - 2rem);
  height: calc(3.1875rem - 1.75rem);
  border-radius: 0.75rem;
  border: solid ${({ theme }) => theme.grey} 0.03125rem;
  resize: none;
  overflow-y: scroll;
`;

export const SelectInput = styled.select`
  width: 100%;
  height: 3.1875rem;
  padding: 1rem;
  color: ${({ theme }) => theme.grey};
  border-radius: 0.75rem;
`;

export const TextArea = styled.textarea`
  width: calc(100% - 2rem);
  height: 7.5rem;
  border-radius: 0.75rem;
  padding: 1rem;
  resize: none;
`;

export const Buttons = styled.div`
  display: flex;
  flex: 0 0 100%;
  flex-direction: row-reverse;
  gap: 1rem;
`;

export const SubmitButton = styled(Button)`
  width: 7.5625rem;
  height: 3.225rem;
`;

export interface Suggestion {
  place_id: string;
  description: string;
}

export interface PlaceDetails {
  formatted_address: string;
  address?: string;
  city?: string;
  postcode?: string;
  state?: string;
  country?: string;
}

export const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Loading = styled.div`
  position: absolute;
  top: 100%;
  left: 1rem;
  color: ${({ theme }) => theme.grey};
  font-size: 0.875rem;
  margin-top: 0.25rem;
  &:before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid ${({ theme }) => theme.grey};
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: 0.5rem;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const SuggestionsList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.grey};
  border-radius: 0.75rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  margin: 0.25rem 0 0 0;
  padding: 0;
  list-style: none;
`;

export const SuggestionItem = styled.li`
  padding: 0.75rem 1rem;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
`;
